import { BoxTypes, RightMainBox } from '~/components/Layout';
import MetaApplicationInfoAndActions from './MetaApplicationInfoAndActions';
import MultiApplicationDetailsTabs from './MultiApplicationDetailsTabs';
import { useQuery, useQueryClient } from '@tanstack/solid-query';
import {
  getClientCredentialByClientId,
  getEnvironmentMultiApplicationDetailQueryKey,
  retryAuthorizedRequests
} from '~/api';
import { useParams } from '@solidjs/router';
import { onCleanup, Show } from 'solid-js';
import SkLoader from '~/components/ui/SkLoader';
import { Breadcrumb } from '~/components/Breadcrumb';
import { Localized } from '~/i18n';
import {
  generateRedirectionToApplicationListURL,
  getTranslationKey
} from './utils';
import { useAppData } from '~/components/AppData';

export default function MultiApplicationDetails() {
  const params = useParams();
  const queryClient = useQueryClient();
  const applicationId = params.applicationId;
  const appData = useAppData();

  const multiAppDetailsQuery = useQuery(() => ({
    queryKey: getEnvironmentMultiApplicationDetailQueryKey(applicationId),
    queryFn: async () =>
      await getClientCredentialByClientId({ clientId: applicationId }),
    retry: retryAuthorizedRequests
  }));

  onCleanup(() => {
    queryClient.removeQueries({
      queryKey: getEnvironmentMultiApplicationDetailQueryKey(applicationId),
      exact: true,
      type: 'all'
    });
  });

  return (
    <RightMainBox
      class={`flex flex-col h-full`}
      boxType={BoxTypes.FULL}
    >
      <Show
        when={multiAppDetailsQuery.isSuccess && multiAppDetailsQuery.data}
        fallback={<SkLoader />}
      >
        <Breadcrumb
          breadcrumbList={[
            {
              label: (
                <Localized translationKey={getTranslationKey('page_header')} />
              ),
              href: generateRedirectionToApplicationListURL(
                appData.selectedEnvironment?.id!
              )
            },
            { label: multiAppDetailsQuery.data?.name }
          ]}
        />
        <MetaApplicationInfoAndActions
          applicationData={multiAppDetailsQuery.data!}
        />
        <MultiApplicationDetailsTabs
          applicationData={multiAppDetailsQuery.data!}
        />
      </Show>
    </RightMainBox>
  );
}
